import React from 'react'

import { ProductIds } from 'core/application/commons/config'

import useCurrentProduct from 'common/hooks/useCurrentProduct'

import GroupHraReimbursements from './groupHra'
import PerksReimbursements from './perks'

const Reimbursements: React.FC = () => {
  const product = useCurrentProduct()
  return product.productId == ProductIds.Perks ? <PerksReimbursements /> : <GroupHraReimbursements />
}

export default Reimbursements
